// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  overflow: -moz-scrollbars-vertical;
  overflow-y: scroll;
}

* {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  box-sizing: border-box;
}

.main-layout .MuiDrawer-paper {
  width: 353px;
  background-color: #fefeff;
  border: none;
}

.modal {
  z-index: 1300;
}

.text_a {
  cursor: pointer;
  color: #1890ff;
  text-decoration: none;
  background-color: transparent;
  outline: none;
  transition: color 0.3s;
  text-decoration: underline;
  -webkit-text-decoration-skip: objects;
}

.ag-grid-header-center .ag-header-cell-label {
  justify-content: center;
  text-align: center;
  font-weight: 500;
}

.titleLinkForTrungTam {
  cursor: pointer;
  color: #007bbe;
}

.my-breadcrumb {
  padding-bottom: 5px;
  margin-bottom: 15px;
  border-bottom: 1px solid #dee2e6;
}

.css-1wuw8dw-MuiBreadcrumbs-separator {
  margin-left: 6px !important;
  margin-right: 6px !important;
}

.component-chitiet {
  height: calc(100vh - 50px);
  position: fixed;
  top: 85px;
  right: 0px;
  background-color: white;
  overflow: auto;
  z-index: 2;
  transition: all 0.3s ease-in-out;
  border-left: 1px solid rgba(0, 0, 0, 0.1764705882);
  /* box-shadow: rgb(0 0 0 / 20%) 0px 8px 10px -5px, rgb(0 0 0 / 4%) 0px 16px 24px 2px, rgb(0 0 0 / 12%) 0px 6px 30px 5px; */
}
.component-chitiet__thaotac {
  display: flex;
  gap: 5px;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 10px;
  padding-left: 10px;
}
.component-chitiet__content {
  padding: 0px 15px 20px 15px;
}

.myform__select {
  display: flex;
  gap: 13px;
  margin-bottom: 15px;
}

.mymodal_header {
  padding: 8px 16px;
  z-index: 99999;
}
.mymodal_body {
  padding: 8px 16px;
}
.mymodal_title {
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8705882353);
}

.table__pagination {
  padding: 15px 0px 15px 20px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  border-top: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  display: flex !important;
  justify-content: space-between;
  align-items: center;
}
.table__pagination span {
  color: grey;
}

.css-1n2mv2k :last-child::after {
  content: "N";
  width: 5px;
}

.css-1n2mv2k :first-child::after {
  content: "2";
  width: 5px;
}

.css-1n2mv2k :nth-child(2)::after {
  content: "3";
  width: 5px;
}

.css-1n2mv2k :nth-child(3)::after {
  content: "4";
  width: 5px;
}

.css-1n2mv2k :nth-child(4)::after {
  content: "5";
  width: 5px;
}

.css-1n2mv2k :nth-child(5)::after {
  content: "6";
  width: 5px;
}

.css-1n2mv2k :nth-child(6)::after {
  content: "7";
  width: 5px;
}

.my-header-class {
  color: #344767;
  font-weight: 600;
  font-size: 13px;
}

.ag-cell-wrap-text {
  word-break: break-word;
}

.ag-theme-alpine {
  --ag-borders: none;
}
.ag-theme-alpine .ag-root-wrapper {
  border: none !important;
  border-radius: 6px;
}
.ag-theme-alpine .ag-root-wrapper .ag-header-row::after {
  display: none;
}
.ag-theme-alpine .ag-root-wrapper .ag-row-hover::after {
  background-color: #e2f0e9 !important;
}
.ag-theme-alpine .ag-root-wrapper .ag-row-hover::before {
  background-color: #e2f0e9 !important;
}
.ag-theme-alpine .ag-root-wrapper .ag-row-selected::before {
  background-color: #e2f0e9 !important;
}
.ag-theme-alpine .ag-root-wrapper .ag-row-selected::after {
  background-color: #e2f0e9 !important;
}
.ag-theme-alpine .ag-overlay .ag-overlay-wrapper.ag-layout-auto-height.ag-overlay-no-rows-wrapper {
  padding-top: 49px !important;
}
.ag-theme-alpine .ag-overlay .ag-overlay-no-row-template {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(197, 197, 197, 0.1098039216);
}

.ag-theme-alpine .ag-header {
  border-bottom: none;
  background-color: rgba(227, 227, 227, 0.8784313725);
}

.ag-theme-alpine .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {
  border-right: none !important;
}

.ag-theme-alpine .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {
  border-left: none !important;
}

.ag-theme-alpine .ag-pinned-left-header {
  border-right: none;
}

.ag-theme-alpine .ag-pinned-right-header {
  border-left: none;
}

.ag-theme-alpine .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {
  border-left: none;
}

.ag-theme-alpine .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {
  border-right: none;
}

.ag-theme-alpine .ag-cell.ag-cell-last-left-pinned:focus {
  border-top: none !important;
  border-bottom: none !important;
  border-right: none !important;
}

.ag-theme-alpine .ag-cell.ag-cell-first-right-pinned:focus {
  border-top: none !important;
  border-bottom: none !important;
  border-right: none !important;
}

.ag-theme-alpine .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {
  border-color: transparent !important;
}

.ag-theme-alpine .ag-row-hover {
  background-color: rgba(33, 150, 243, 0.1) !important;
}

.ag-header-cell-label {
  text-overflow: clip;
  overflow: visible;
  white-space: normal;
}

.ag-header-cell-label .ag-header-cell-text {
  white-space: normal !important;
}

.ag-theme-alpine .ag-large-text-input {
  font-size: 14px !important;
  padding: 0px !important;
}

.ag-theme-alpine .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {
  width: 100%;
  border: none;
  border-radius: 2px;
  outline: aqua;
  flex: auto;
}

.simple-input-editor {
  width: 100%;
  margin: 0px 0.5px;
  height: 93%;
  border-radius: 2px;
  border: 1.5px solid rgba(33, 149, 243, 0.5960784314);
  padding: 0px 10px;
  outline: aqua;
}

.mythaotac {
  display: flex;
  align-items: center;
  gap: 3px;
  z-index: 2;
  cursor: pointer;
}
.mythaotac__delete {
  padding: 10px;
}
.mythaotac__delete__title {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 5px;
}
.mythaotac__delete__button {
  display: flex;
  justify-content: center;
  gap: 10px;
}
.mythaotac__delete__button p {
  font-size: 16px;
  color: #1976d2;
  font-weight: 500;
  cursor: pointer;
}

.qcvn-mucdichsudung__title {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  padding-right: 10px;
  align-items: center;
}
.qcvn-mucdichsudung__title h3 {
  color: #344767;
  font-weight: 500;
}
.qcvn-mucdichsudung__table {
  padding: 15px 10px 10px 10px;
}

:root {
  --toastify-color-dark: #121212;
  --toastify-color-info: #0288d1;
  --toastify-color-success: #41aa46;
  --toastify-color-warning: #f1c40f;
  --toastify-color-error: #d32f2f;
  --toastify-toast-min-height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/styles/index.scss"],"names":[],"mappings":"AAAA;EACI,kCAAA;EACA,kBAAA;AACJ;;AACA;EACI,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,sBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,yBAAA;EACA,YAAA;AAGJ;;AADA;EACI,aAAA;AAIJ;;AAFA;EACI,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,qCAAA;AAKJ;;AAHA;EACI,uBAAA;EACA,kBAAA;EACA,gBAAA;AAMJ;;AAJA;EACI,eAAA;EACA,cAAA;AAOJ;;AAJA;EACI,mBAAA;EACA,mBAAA;EACA,gCAAA;AAOJ;;AALA;EACI,2BAAA;EACA,4BAAA;AAQJ;;AANA;EACI,0BAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,UAAA;EACA,gCAAA;EACA,kDAAA;EACA,0HAAA;AASJ;AARI;EACI,aAAA;EACA,QAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAUR;AARI;EACI,2BAAA;AAUR;;AANI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AASR;;AALI;EACI,iBAAA;EACA,cAAA;AAQR;AANI;EACI,iBAAA;AAQR;AANI;EACI,eAAA;EACA,kCAAA;AAQR;;AALA;EACI,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,8BAAA;EACA,mBAAA;AAQJ;AAPI;EACI,WAAA;AASR;;AANA;EACI,YAAA;EACA,UAAA;AASJ;;AAPA;EACI,YAAA;EACA,UAAA;AAUJ;;AARA;EACI,YAAA;EACA,UAAA;AAWJ;;AATA;EACI,YAAA;EACA,UAAA;AAYJ;;AAVA;EACI,YAAA;EACA,UAAA;AAaJ;;AAXA;EACI,YAAA;EACA,UAAA;AAcJ;;AAZA;EACI,YAAA;EACA,UAAA;AAeJ;;AAZA;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AAeJ;;AAbA;EACI,sBAAA;AAgBJ;;AAbA;EACI,kBAAA;AAgBJ;AAfI;EACI,uBAAA;EACA,kBAAA;AAiBR;AAhBQ;EACI,aAAA;AAkBZ;AAhBQ;EACI,oCAAA;AAkBZ;AAhBQ;EACI,oCAAA;AAkBZ;AAhBQ;EACI,oCAAA;AAkBZ;AAhBQ;EACI,oCAAA;AAkBZ;AAdQ;EACI,4BAAA;AAgBZ;AAdQ;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mDAAA;AAgBZ;;AAZA;EACI,mBAAA;EACA,mDAAA;AAeJ;;AAbA;EACI,6BAAA;AAgBJ;;AAdA;EACI,4BAAA;AAiBJ;;AAfA;EACI,kBAAA;AAkBJ;;AAhBA;EACI,iBAAA;AAmBJ;;AAjBA;EACI,iBAAA;AAoBJ;;AAlBA;EACI,kBAAA;AAqBJ;;AAnBA;EACI,2BAAA;EACA,8BAAA;EACA,6BAAA;AAsBJ;;AApBA;EACI,2BAAA;EACA,8BAAA;EACA,6BAAA;AAuBJ;;AArBA;EACI,oCAAA;AAwBJ;;AAtBA;EACI,oDAAA;AAyBJ;;AAvBA;EACI,mBAAA;EACA,iBAAA;EACA,mBAAA;AA0BJ;;AAxBA;EACI,8BAAA;AA2BJ;;AAzBA;EACI,0BAAA;EACA,uBAAA;AA4BJ;;AAzBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;AA4BJ;;AA1BA;EACI,WAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,oDAAA;EACA,iBAAA;EACA,aAAA;AA6BJ;;AA3BA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EAGA,UAAA;EACA,eAAA;AA4BJ;AA3BI;EACI,aAAA;AA6BR;AA5BQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AA8BZ;AA5BQ;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AA8BZ;AA7BY;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA+BhB;;AAzBI;EACI,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA4BR;AA3BQ;EACI,cAAA;EACA,gBAAA;AA6BZ;AA1BI;EACI,4BAAA;AA4BR;;AAzBA;EACI,8BAAA;EACA,8BAAA;EACA,iCAAA;EACA,iCAAA;EACA,+BAAA;EACA,iCAAA;AA4BJ","sourcesContent":["html {\r\n    overflow: -moz-scrollbars-vertical;\r\n    overflow-y: scroll;\r\n}\r\n* {\r\n    margin: 0;\r\n    padding: 0;\r\n    border: 0;\r\n    font-size: 100%;\r\n    box-sizing: border-box;\r\n}\r\n.main-layout .MuiDrawer-paper {\r\n    width: 353px;\r\n    background-color: #fefeff;\r\n    border: none;\r\n}\r\n.modal {\r\n    z-index: 1300;\r\n}\r\n.text_a {\r\n    cursor: pointer;\r\n    color: #1890ff;\r\n    text-decoration: none;\r\n    background-color: transparent;\r\n    outline: none;\r\n    transition: color 0.3s;\r\n    text-decoration: underline;\r\n    -webkit-text-decoration-skip: objects;\r\n}\r\n.ag-grid-header-center .ag-header-cell-label {\r\n    justify-content: center;\r\n    text-align: center;\r\n    font-weight: 500;\r\n}\r\n.titleLinkForTrungTam {\r\n    cursor: pointer;\r\n    color: #007bbe;\r\n}\r\n\r\n.my-breadcrumb {\r\n    padding-bottom: 5px;\r\n    margin-bottom: 15px;\r\n    border-bottom: 1px solid #dee2e6;\r\n}\r\n.css-1wuw8dw-MuiBreadcrumbs-separator {\r\n    margin-left: 6px !important;\r\n    margin-right: 6px !important;\r\n}\r\n.component-chitiet {\r\n    height: calc(100vh - 50px);\r\n    position: fixed;\r\n    top: 85px;\r\n    right: 0px;\r\n    background-color: white;\r\n    overflow: auto;\r\n    z-index: 2;\r\n    transition: all 0.3s ease-in-out;\r\n    border-left: 1px solid #0000002d;\r\n    /* box-shadow: rgb(0 0 0 / 20%) 0px 8px 10px -5px, rgb(0 0 0 / 4%) 0px 16px 24px 2px, rgb(0 0 0 / 12%) 0px 6px 30px 5px; */\r\n    &__thaotac {\r\n        display: flex;\r\n        gap: 5px;\r\n        align-items: center;\r\n        margin-bottom: 10px;\r\n        margin-top: 10px;\r\n        padding-left: 10px;\r\n    }\r\n    &__content {\r\n        padding: 0px 15px 20px 15px;\r\n    }\r\n}\r\n.myform {\r\n    &__select {\r\n        display: flex;\r\n        gap: 13px;\r\n        margin-bottom: 15px;\r\n    }\r\n}\r\n.mymodal {\r\n    &_header {\r\n        padding: 8px 16px;\r\n        z-index: 99999;\r\n    }\r\n    &_body {\r\n        padding: 8px 16px;\r\n    }\r\n    &_title {\r\n        font-size: 18px;\r\n        color: #000000de;\r\n    }\r\n}\r\n.table__pagination {\r\n    padding: 15px 0px 15px 20px;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 4px;\r\n    border-top: 0px;\r\n    border-top-left-radius: 0px;\r\n    border-top-right-radius: 0px;\r\n    display: flex !important;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    span {\r\n        color: grey;\r\n    }\r\n}\r\n.css-1n2mv2k :last-child::after {\r\n    content: 'N';\r\n    width: 5px;\r\n}\r\n.css-1n2mv2k :first-child::after {\r\n    content: '2';\r\n    width: 5px;\r\n}\r\n.css-1n2mv2k :nth-child(2)::after {\r\n    content: '3';\r\n    width: 5px;\r\n}\r\n.css-1n2mv2k :nth-child(3)::after {\r\n    content: '4';\r\n    width: 5px;\r\n}\r\n.css-1n2mv2k :nth-child(4)::after {\r\n    content: '5';\r\n    width: 5px;\r\n}\r\n.css-1n2mv2k :nth-child(5)::after {\r\n    content: '6';\r\n    width: 5px;\r\n}\r\n.css-1n2mv2k :nth-child(6)::after {\r\n    content: '7';\r\n    width: 5px;\r\n}\r\n\r\n.my-header-class {\r\n    color: #344767;\r\n    font-weight: 600;\r\n    font-size: 13px;\r\n}\r\n.ag-cell-wrap-text {\r\n    word-break: break-word;\r\n}\r\n\r\n.ag-theme-alpine {\r\n    --ag-borders: none;\r\n    .ag-root-wrapper {\r\n        border: none !important;\r\n        border-radius: 6px;\r\n        .ag-header-row::after {\r\n            display: none;\r\n        }\r\n        .ag-row-hover::after {\r\n            background-color: #e2f0e9 !important;\r\n        }\r\n        .ag-row-hover::before {\r\n            background-color: #e2f0e9 !important;\r\n        }\r\n        .ag-row-selected::before {\r\n            background-color: #e2f0e9 !important;\r\n        }\r\n        .ag-row-selected::after {\r\n            background-color: #e2f0e9 !important;\r\n        }\r\n    }\r\n    .ag-overlay {\r\n        .ag-overlay-wrapper.ag-layout-auto-height.ag-overlay-no-rows-wrapper {\r\n            padding-top: 49px !important;\r\n        }\r\n        .ag-overlay-no-row-template {\r\n            width: 100%;\r\n            height: 100%;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            background-color: #c5c5c51c;\r\n        }\r\n    }\r\n}\r\n.ag-theme-alpine .ag-header {\r\n    border-bottom: none;\r\n    background-color: #e3e3e3e0;\r\n}\r\n.ag-theme-alpine .ag-cell.ag-cell-last-left-pinned:not(.ag-cell-range-right):not(.ag-cell-range-single-cell) {\r\n    border-right: none !important;\r\n}\r\n.ag-theme-alpine .ag-cell.ag-cell-first-right-pinned:not(.ag-cell-range-left):not(.ag-cell-range-single-cell) {\r\n    border-left: none !important;\r\n}\r\n.ag-theme-alpine .ag-pinned-left-header {\r\n    border-right: none;\r\n}\r\n.ag-theme-alpine .ag-pinned-right-header {\r\n    border-left: none;\r\n}\r\n.ag-theme-alpine .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-right-spacer:not(.ag-scroller-corner) {\r\n    border-left: none;\r\n}\r\n.ag-theme-alpine .ag-body-horizontal-scroll:not(.ag-scrollbar-invisible) .ag-horizontal-left-spacer:not(.ag-scroller-corner) {\r\n    border-right: none;\r\n}\r\n.ag-theme-alpine .ag-cell.ag-cell-last-left-pinned:focus {\r\n    border-top: none !important;\r\n    border-bottom: none !important;\r\n    border-right: none !important;\r\n}\r\n.ag-theme-alpine .ag-cell.ag-cell-first-right-pinned:focus {\r\n    border-top: none !important;\r\n    border-bottom: none !important;\r\n    border-right: none !important;\r\n}\r\n.ag-theme-alpine .ag-ltr .ag-has-focus .ag-cell-focus:not(.ag-cell-range-selected) {\r\n    border-color: transparent !important;\r\n}\r\n.ag-theme-alpine .ag-row-hover {\r\n    background-color: rgb(33, 150, 243, 0.1) !important;\r\n}\r\n.ag-header-cell-label {\r\n    text-overflow: clip;\r\n    overflow: visible;\r\n    white-space: normal;\r\n}\r\n.ag-header-cell-label .ag-header-cell-text {\r\n    white-space: normal !important;\r\n}\r\n.ag-theme-alpine .ag-large-text-input {\r\n    font-size: 14px !important;\r\n    padding: 0px !important;\r\n}\r\n\r\n.ag-theme-alpine .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {\r\n    width: 100%;\r\n    border: none;\r\n    border-radius: 2px;\r\n    outline: aqua;\r\n    flex: auto;\r\n}\r\n.simple-input-editor {\r\n    width: 100%;\r\n    margin: 0px 0.5px;\r\n    height: 93%;\r\n    border-radius: 2px;\r\n    border: 1.5px solid #2195f398;\r\n    padding: 0px 10px;\r\n    outline: aqua;\r\n}\r\n.mythaotac {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 3px;\r\n    // visibility: hidden;\r\n    // position: relative;\r\n    z-index: 2;\r\n    cursor: pointer;\r\n    &__delete {\r\n        padding: 10px;\r\n        &__title {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: 5px;\r\n            margin-bottom: 5px;\r\n        }\r\n        &__button {\r\n            display: flex;\r\n            justify-content: center;\r\n            gap: 10px;\r\n            p {\r\n                font-size: 16px;\r\n                color: #1976d2;\r\n                font-weight: 500;\r\n                cursor: pointer;\r\n            }\r\n        }\r\n    }\r\n}\r\n.qcvn-mucdichsudung {\r\n    &__title {\r\n        margin-top: 5px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        padding-right: 10px;\r\n        align-items: center;\r\n        h3 {\r\n            color: #344767;\r\n            font-weight: 500;\r\n        }\r\n    }\r\n    &__table {\r\n        padding: 15px 10px 10px 10px;\r\n    }\r\n}\r\n:root {\r\n    --toastify-color-dark: #121212;\r\n    --toastify-color-info: #0288d1;\r\n    --toastify-color-success: #41aa46;\r\n    --toastify-color-warning: #f1c40f;\r\n    --toastify-color-error: #d32f2f;\r\n    --toastify-toast-min-height: 30px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
